import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Base',
    component: DefaultLayout,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/pages/Home.vue'),
      },
      {
        path: '/tripplan',
        name: 'TripPlan',
        component: () => import('@/views/pages/TripPlan.vue')
      },
      {
        path: '/plannedtrip',
        name: 'PlannedTrip',
        component: () => import('@/views/pages/PlannedTrip.vue')
      }
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

 router.beforeEach(async(to,from)=>{
    var token = sessionStorage.getItem('accessToken');
    if (to.path == '/') {
      router.push('/home');
      return false;
    }
    return true;
 })


// router.beforeEach(async (to, from) => {

//   var token = sessionStorage.getItem('accessToken');
//   if ((token && token != 'null') || to.path == '/login' || to.path == '/registration') {
    
//     return true;
//   }
//   else {
//     router.push('/login');
//     return false;
//   }

// })

export default router
